import config, { API } from '../../config';

export async function getSignedUrl(SFMediaSubmissionID, fileName, contentType, action = 'WRITE') {
  const myInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      SFMediaSubmissionID: SFMediaSubmissionID,
      Filename: fileName,
      ContentType: contentType,
      Action: action,
    }),
  };
  // console.log(JSON.stringify(myInit));
  const myRequest = new Request(`${API}/v1/getSignedURL`);
  let singedUrlResponse = await fetch(myRequest, myInit);
  // console.log('[I] signedURLRespone: ', singedUrlResponse);
  if (singedUrlResponse.ok) {
    let signedURL = await singedUrlResponse.json();
    // console.log('signedURL body: ', signedURL);
    return signedURL.data;
  } else {
    return false;
  }
}

export async function uploadFile(signedUrl, file) {
  console.log('[*] uploadFile: ', signedUrl, file);
  const reqParams = {
    method: 'PUT',
    body: file,
  };

  try {
    let uploadResponse = await fetch(signedUrl, reqParams);
    let uploadResponseJson = await uploadResponse.json();
    console.log('s3UploadReposne: ', uploadResponse, uploadResponseJson);
  } catch (err) {
    console.log('[E] Error uploading file to s3...', err);
  }

  // axios
  //           .put(`${signedUrl}`, file, {
  //             headers: {
  //               'Content-Type': file.type,
  //             },
  //           })
}

export function bytesToSize(x) {
  const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  let l = 0,
    n = parseInt(x, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  return n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l];
}

export function secondsToTime(seconds) {
  if (Number.isNaN(seconds)) return '...';
  if (seconds <= 60) return 'few seconds';
  if (seconds / 60 <= 60) return Math.ceil(seconds / 60) + ' minutes';
  if (seconds / 3600 <= 60) return Math.ceil(seconds / 3600) + ' hours';
  return Math.ceil(seconds / 86400) + ' days';
}

export function remainigPercentFormat(totalSizeRemaining, allFileTotalSize) {
  let result = Math.ceil((totalSizeRemaining * 100) / allFileTotalSize);
  return Number.isNaN(result) ? '' : result + '%';
}
